import type { ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { surfaceForPath, MODALITY } from './nav';

// The mockup content head: back link, taxonomy layerband, mono/plain title +
// actions, edit-modality badge, description. The full breadcrumb lives in the
// crumbbar (ConsoleLayout); here we restate the layer + how this surface is
// edited. See docs/superpowers/specs/2026-07-21-console-ia-editability-design.md.
export function AdminPage({ title, description, actions, backTo, mono, children }: {
  title: string; description?: string; actions?: ReactNode;
  backTo?: { to: string; label: string }; mono?: boolean; children: ReactNode;
}) {
  const { pathname } = useLocation();
  const surface = surfaceForPath(pathname);
  const group = surface?.group;
  const mod = surface?.item.mod;
  return (
    <>
      {backTo ? (
        <Link to={backTo.to} className="backlink"><span aria-hidden>←</span> {backTo.label}</Link>
      ) : null}
      {group?.color ? (
        <div className={`layerband ${group.color}`}>
          <span className={`dot ${group.color}`} />
          <span>{group.title}{group.sub ? ` · ${group.sub}` : ''}</span>
        </div>
      ) : null}
      <div className="titlebar">
        <h1 className={`title ${mono ? '' : 'plain'}`}>{title}</h1>
        {actions ? <div className="pagehead-actions">{actions}</div> : null}
      </div>
      {mod ? (
        <div className="badgerow">
          <span className={`mod ${MODALITY[mod].cls}`} title={MODALITY[mod].title}>{MODALITY[mod].label}</span>
        </div>
      ) : null}
      {description ? <p className="desc">{description}</p> : null}
      {children}
    </>
  );
}
